/**
 * The audience for which the config is intended.
 */
export enum AiAgentConfigAudience {
	/**
	 * The config is intended for a tenant.
	 */
	Tenant = 'tenant',

	/**
	 * The config is intended for a user.
	 */
	User = 'user',
}

/**
 * Value type of the config.
 */
export enum AiAgentConfigValueType {
	String = 'string',
	Int = 'int',
	Bool = 'bool',
	Double = 'double',
}

/**
 * UI view type of the config.
 */
export enum AiAgentConfigUiView {
	RadioChoice = 'radioChoice',
	ComboBoxChoice = 'comboBoxChoice',
	OnOff = 'onOff',
	SingleValue = 'singleValue',
}

export interface AiAgentConfigSchema {
	key: string;
	description?: string;
	audience: AiAgentConfigAudience;
	valueType: AiAgentConfigValueType;
	uiView: AiAgentConfigUiView;
	defaultValue?: unknown;
	defaultValueEntitlementRID?: string;
}

export interface AiAgentConfigValue {
	key: string;
	agentRID: string;
	value: unknown;
	schema?: AiAgentConfigSchema;
}

/**
 * Generic paged response structure
 */
export interface DataPageResult<T> {
	filteredCount?: number;
	overallCount?: number;
	nextSkip?: number;
	resources?: T[];
}
